import React, { useMemo, useState } from "react";
import propTypes from "prop-types";

import { useFormContext, Header, Label, Input, Select } from "../../Components/SmartForm";

const PersonalInformation = ({
    countries,
    regions,
    className,
    ...props,
}) => {
    const context = useFormContext();
    const { form } = context;
    const countryFieldName = context.getScopedName("country_id");
    const regionFieldName = context.getScopedName("region_id");
    const countryCode = form.getValue(countryFieldName, "");
    const [lastCountry, setLastCountry] = useState(countryCode);

    const activeRegions = useMemo(
        () => (regions[countryCode] || false),
        [regions, countryCode]
    );

    if (lastCountry !== countryCode) {
        if (lastCountry !== "") {
            form.setValue(regionFieldName, "");
        }
        setLastCountry(countryCode);
    }

    return (
        <div className={`card ${className}`} {...props} >
            <div className="card-header">
                <Header text="Your Information" />
            </div>
            <div className="card-body">
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <Label
                            input="firstName"
                            required
                        >
                            First Name
                        </Label>
                        <Input
                            name="firstName"
                            type="text"
                            className="form-control"
                            required
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <Label
                            input="lastName"
                            required
                        >
                            Last Name
                        </Label>
                        <Input
                            name="lastName"
                            type="text"
                            className="form-control"
                            required
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-6">
                        <Label
                            input="email"
                            required
                        >
                            Email Address
                        </Label>
                        <Input
                            name="email"
                            label="Email Address"
                            type="email"
                            className="form-control"
                            required
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <Label
                            input="phone"
                            required
                        >
                            Phone Number
                        </Label>
                        <Input
                            name="phone"
                            label="Phone Number"
                            type="tel"
                            className="form-control"
                            required
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-6">
                        <Label
                            input="street"
                            required
                        >
                            Street
                        </Label>
                        <Input
                            name="street"
                            type="text"
                            className="form-control"
                            required
                        />
                    </div>
                    <div className="form-group col-6">
                        <Label input="company">
                            Company
                        </Label>
                        <Input
                            name="company"
                            type="text"
                            className="form-control"
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-6">
                        <Label
                            input="postalCode"
                            required
                        >
                            Zip / Postal Code
                        </Label>
                        <Input
                            name="postalCode"
                            label="Zip / Postal Code"
                            type="text"
                            className="form-control"
                            required
                        />
                    </div>
                    <div className="form-group col-6">
                        <Label
                            input="city"
                            required
                        >
                            City
                        </Label>
                        <Input
                            name="city"
                            type="text"
                            className="form-control"
                            required
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-6">
                        <Label
                            input="country_id"
                            required
                        >
                            Country
                        </Label>
                        <Select
                            name="country_id"
                            label="Country"
                            className="form-control"
                            required
                        >
                            <option hidden value="">Select</option>
                            {countries.map(({code, name}) => (
                                <option key={code} value={code}>{name}</option>
                            ))}
                        </Select>
                    </div>
                    <div className="form-group col-6">
                        <Label
                            input="region_id"
                            required={activeRegions ? true : false}
                        >
                            Region
                        </Label>
                        {activeRegions ? (
                            <Select
                                name="region_id"
                                label="Region"
                                className="form-control"
                                required
                            >
                                <option hidden value="">Select</option>
                                {activeRegions.map(({id, name}) => (
                                    <option key={id} value={id}>{name}</option>
                                ))}
                            </Select>
                        ) : (
                            <Input
                                name="region_id"
                                type="text"
                                className="form-control"
                                disabled={!countryCode}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

PersonalInformation.propTypes = {
    className: propTypes.string,
    countries: propTypes.array,
    regions: propTypes.object,
};

export default PersonalInformation;
